<template>
  <div>
    
    <v-card outlined>
      <v-card-title primary-title class='white white--text justify-center pa-0'>
        <span class="title-card ml-3">Detalhes do evento</span>
        <v-spacer></v-spacer>
        <v-btn @click="enableEditing()" text small
          :color="!is_editing ? 'normal' : 'red'" 
          class="btn-primary"
          :disabled="loading"
          v-if="is_component_show_event && !is_editing"
        >
          <v-icon left>
            mdi-pencil
          </v-icon>
          {{!is_editing ? 'Editar' : 'Cancelar'}}  
        </v-btn>
      </v-card-title>
      <v-card-text>
      <!-- fim dialog color_picker -->
        <v-form class="mx-4 mt-4" ref="form_info" v-model="valid" @submit.prevent="is_component_show_event ? updateEvent() : nextStep()">
          <v-row class="pa-0" v-if="is_component_show_event">
            <v-col cols='12' class="mx-2 py-2">
              <v-btn v-if="is_editing" tile type="submit" color="error" class="mb-4 mr-2" align="center" @click="cancelEditing()">
                <v-icon left>
                  mdi-cancel
                </v-icon>
                Cancelar
              </v-btn>
              <v-btn v-if="is_editing" tile type="submit" color="success" class="mb-4 mr-2" align="center" @click="updateEvent()">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
            </v-col>
          </v-row>
          <template>
            <div class="pt-5">
              <v-row class="pa-0">
                <v-col cols='12' sm='8' class="py-2">
                  <v-text-field dense outlined v-model="address" label="Endereço completo"></v-text-field>
                </v-col>
                <v-col cols='12' sm='2' class="py-2">
                  <v-text-field v-mask="zipMask" dense outlined v-model="zip" label="CEP" @input="fetchZip"></v-text-field>
                </v-col>
                <v-col cols='12' sm='2' class="py-2">
                  <v-select :menu-props="{ bottom: true, offsetY: true }" dense outlined :items="size_items" label="Tamanho" v-model="size"></v-select>
                </v-col>
              </v-row>
              <v-textarea dense outlined v-model="description" label="Descrição"></v-textarea>
            </div>
          </template>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import { mapState, mapActions } from 'vuex';
  import cep from 'cep-promise'

  export default {
    name: 'FormEventDetails',
    mixins: [ validations ],
    props: {
      is_component_show_event: {
        type: Boolean
      },
      is_component_create_event: {
        type: Boolean
      },
    },
    components: {
    },
    data() {
      return {
        is_editing: false,
        size: '',
        zip: '', 
        address: '',
        zipMask: '##.###-###',
        description: '',
        size_items: [
          {
            text: 'Grande',
            value: 'large'
          },
          {
            text: 'Médio',
            value: 'medium'
          },
          {
            text: 'Pequeno',
            value: 'small'
          },
        ],
        valid: true,
      }
    },
    methods: {
      enableEditing(){
        this.is_editing = !this.is_editing
      },
      cancelEditing(){
        this.is_editing = !this.is_editing
        this.getData()
      },
      fetchZip(zip) {
        if(!this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g,'')))) {
          this.loading_zip = true
          cep(zip.replace(/[.-]/g,'')).then(endereco => {
            const { street, neighborhood, city, state } = endereco
            let num = this.address.split('Nº: ')[1] || ''
            this.address = `CEP ${this.zip}, ${street || 'Rua: '}, ${neighborhood || 'Bairro: '}, ${city}, ${state}, Nº: ${num}`
          }).finally(()=>{
            this.loading_zip = false
          })
        }
      },
    },
    computed: {
    },
  }
</script>

<style lang="scss" scoped>

</style>